type PaginationProps = {
  current: number;
  total: number;
  onChange: (page: number) => void;
};

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-2 mt-8">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="w-9 h-9 rounded-md border border-background-300 flex items-center justify-center text-foreground-600 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-500 text-background-50 font-bold"
              : "border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="w-9 h-9 rounded-md border border-background-300 flex items-center justify-center text-foreground-600 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>
    </div>
  );
}